/**
 * Parse a Resource.version string ("1", "2", …) into a number.
 * Falls back to 0 when the value is missing or non-numeric so callers
 * never accidentally treat a malformed version as "latest".
 */
export const parseResourceVersion = (version) => {
    const parsed = parseInt(version || '0', 10);
    return Number.isFinite(parsed) ? parsed : 0;
};
/**
 * Returns true when at least one of the candidate dataset resources
 * (typically all PUBLISHED resources sharing the same `key`) is active
 * and has a numerically greater `version` than `currentDatasetVersion`.
 *
 * `currentDatasetId` is excluded from the comparison so the chart's
 * own referenced version cannot match itself.
 */
export const hasNewerDatasetVersion = (candidates, currentDatasetId, currentDatasetVersion) => {
    const currentVersion = parseResourceVersion(currentDatasetVersion);
    return candidates.some((candidate) => candidate.id !== currentDatasetId && candidate.active && parseResourceVersion(candidate.version) > currentVersion);
};
